import { FC, useEffect } from 'react';

import { vacancyStatisticsHHLink } from 'utils/clickme';
import { CampaignType } from 'utils/constants/campaign';
import { NON_BREAKING_SPACE, SPACE } from 'utils/constants/common';

import { Card, Link, Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { getCampaignType } from 'components/CpcFlexibleCreate/CpcForm/AdCampaignInformation/getCampaignType';

import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    tip: 'AdCreate.AdForm.AdCampaignType.textMagritte',
    [CampaignType.Advertising]: 'AdCreate.AdForm.AdCampaignType.advertising',
    [CampaignType.Information]: 'AdCreate.AdForm.AdCampaignType.information',
    statistic: {
        part1: 'AdCreate.StatisticsLink.part1',
        link: 'AdCreate.StatisticsLink.link',
        part2: 'AdCreate.StatisticsLink.part2',
    },
};

export const AdCampaignInformation: FC = () => {
    const campaignType = useSelector((state) => state.createCampaign.campaignType);
    const campaignId = useSelector((state) => state.createCampaign.campaignId);
    const { bannerVacancyId } = useSelector((state) => state.createBanner);

    const dispatch = useDispatch();

    const trl = useTrls();

    useEffect(() => {
        if (!campaignType && !campaignId) {
            void dispatch(getCampaignType());
        }
    }, [campaignType, campaignId, dispatch]);

    if (campaignId) {
        return null;
    }

    return (
        <>
            <VSpacing default={32} />
            {campaignType && (
                <>
                    <Text style="secondary">
                        {trl(TrlKeys.tip)}
                        {SPACE}
                        {trl(TrlKeys[campaignType])}
                    </Text>
                    <VSpacing default={32} />
                </>
            )}
            {bannerVacancyId && (
                <Card padding={20} borderRadius={24} stretched style="secondary">
                    <Text Element="span" typography="paragraph-2-regular">
                        {trl(TrlKeys.statistic.part1)}
                    </Text>
                    {NON_BREAKING_SPACE}
                    <Link
                        inline
                        href={vacancyStatisticsHHLink(bannerVacancyId)}
                        target="_blank"
                        rel="noopener noreferrer"
                        typography="paragraph-2-regular"
                    >
                        {trl(TrlKeys.statistic.link)}
                    </Link>
                    {SPACE}
                    <Text Element="span" typography="paragraph-2-regular">
                        {trl(TrlKeys.statistic.part2)}
                    </Text>
                </Card>
            )}
        </>
    );
};
